export const KLAB_UTC_OFFSET_HOURS = 5;

/**
 * Offset string para Angular DatePipe. Simétrico con
 * `KLAB_UTC_OFFSET_HOURS` y con el backend (event-processor
 * `DEFAULT_FALLBACK_ZONE`). Mantener ambas constantes alineadas.
 *
 * Uso en template:
 *   {{ value | date:'HH:mm:ss':KLAB_DISPLAY_OFFSET }}
 *
 * Sin esto, Angular usa la zona del navegador, lo que genera
 * que algunos usuarios vean horas como 00:00 (UTC) o 03:57
 * en vez de la hora local Lima (casos #31 y #34).
 */
export const KLAB_DISPLAY_OFFSET = '-0500';

export function localDateToUtcDateString(date: Date): string {
    const utc = new Date(date.getTime() + KLAB_UTC_OFFSET_HOURS * 60 * 60 * 1000);
    return utc.toISOString().substring(0, 10);
}

export function applyKlabDisplayTimeOffset(date: Date): Date {
    if (!date || Number.isNaN(date.getTime())) return date;
    return new Date(date.getTime() + KLAB_UTC_OFFSET_HOURS * 60 * 60 * 1000);
}
